// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".not-found-page .centered,.not-found-page .full-page>.content{min-height:calc(100vh - 160px)}.not-found-page .not-found-icon{margin-right:10px}.not-found-page .centered{display:flex;padding-bottom:150px;flex-direction:column;align-items:center;justify-content:center;color:#fff}.not-found-page .centered h1,.not-found-page .centered i{font-size:50px}.not-found-page .centered p{font-size:20px}", ""]);
// Exports
module.exports = exports;
